
export default {
  addPoint({ commit }, point) {
    commit("ADD", point);
  },
  setPoint({ commit }, points) {
    commit("SET", points)
  },
  clear({ commit }) {
    commit("CLEAR")
  },
  setEditMode({ commit }, mode) {
    commit("SET_EDIT_MODE", mode)
  },
};
